import { Chip } from '@mui/material'

const EnvironmentChip = () => {
  const environment = process.env.RAILS_ENV
  const color = environment === 'production' ? 'error' : 'default'

  return <Chip label={environment} color={color} />
}

export default EnvironmentChip
